import { mediaMax } from '@/app/styles/breakpoints'
import { Flex, Typography } from 'antd'
import styled from 'styled-components'

const { Text } = Typography

export const TransferSection = styled(Flex)`
  height: 100%;
`

export const Content = styled(Flex)`
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.divider};
  padding: 16px;
  flex: 1;
  ${mediaMax.sm} {
    border: none;
    padding: 0;
  }
`

export const TransferHeader = styled(Flex)``

export const ExpandButton = styled(Flex)<{ isOpen?: boolean }>`
  transition: transform 0.2s ease;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export const SelectCount = styled(Text)`
  color: ${(props) => props.theme.colors.textLight};
`
